import React from 'react';
import {renderFieldLabel} from 'src/app/forms/renderFieldLabel';
import {TagsInput} from 'src/design/atoms/TagsInput';
import type {IFormFieldV2} from 'src/types/FormV2';

export interface FormTagsInputV2Props {
  field: IFormFieldV2;
  value: string[];
  error?: string;
  onChange: (name: string, value: string[]) => void;
}

export const FormTagsInputV2 = React.memo<FormTagsInputV2Props>(
  ({field, value, error, onChange}: FormTagsInputV2Props) => (
    <TagsInput
      label={renderFieldLabel(field)}
      ariaLabel={field.label}
      description={field.description}
      value={Array.isArray(value) ? value : []}
      error={error}
      required={field.required}
      placeholder={field.placeholder}
      disabled={field.disabled}
      onChangeCallback={val => onChange(field.name, val)}
    />
  )
);
